export function trackEvent(name, params = {}) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
}

// The floating button and the inline booking embed share one Cal namespace,
// so the listener must be registered once or each booking is counted twice.
let calBookingTracked = false;

export function trackCalBookings(cal) {
  if (calBookingTracked) {
    return;
  }

  calBookingTracked = true;
  cal('on', {
    action: 'bookingSuccessfulV2',
    callback: () => trackEvent('generate_lead', { lead_source: 'cal_booking' }),
  });
}
